import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
};

const LabelDescription = ({ children, className }) => (
  <div
    className={clsx(
      'text-gray-500 dark:text-muted-foreground mb-1 font-normal text-xs -mt-0.5',
      className,
    )}
  >
    {children}
  </div>
);

LabelDescription.propTypes = propTypes;

export default LabelDescription;
